import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { useEffect, useMemo, useState } from "react";
import { boatsFetch } from "@/src/lib/boatsFetch";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { useWatch } from "react-hook-form";
import qs from "qs";
import { ComboboxMulti } from "../../../../components/ui/combobox-multi";

export function Model() {
  const [models, setModels] = useState<{ label: string; options: string[] }[]>([]);

  const manufacturer = useWatch<YachtsFiltersFormT, "manufacturer">({
    name: "manufacturer",
  });

  const query = qs.stringify({ manufacturer }, { indices: false });

  const fetchModels = () =>
    boatsFetch<{ data: { label: string; options: string[] }[] }>(`/search/models?${query ? query : ""}`);

  useEffect(() => {
    if (!!manufacturer?.length) {
      fetchModels().then((res) => setModels(res.data));
    }
  }, [manufacturer]);

  const flattenModels = useMemo(() => {
    const mappedModels = models?.map((m) => {
      return m.options?.map((option) => ({
        value: option,
        label: option,
      }));
    });
    return mappedModels.flat();
  }, [models]);

  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-3">Model (select manufacturer first)</h3>
      <div className="flex flex-col gap-y-6 w-full">
        <div className="flex gap-x-4">
          <FormField<YachtsFiltersFormT, "model">
            name="model"
            render={({ field }) => {
              return (
                <FormItem className="w-[294px]">
                  <FormControl>
                    <ComboboxMulti
                      className="flex w-full"
                      placeholder="Search for models..."
                      value={field.value ?? []}
                      onChange={(v) => {
                        field.onChange(v);
                      }}
                      defaultOptions={flattenModels}
                    />
                  </FormControl>
                </FormItem>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
}
